import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "asset-view-wrapper" }
const _hoisted_2 = { class: "assets-table-container" }
const _hoisted_3 = { class: "wad-topbar" }
const _hoisted_4 = { class: "wad-range-pills" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "wp-loading"
}
const _hoisted_7 = { class: "wp-loading__text" }
const _hoisted_8 = {
  key: 1,
  class: "alert alert-danger m-3"
}
const _hoisted_9 = { class: "wl-kpis mb-4" }
const _hoisted_10 = { class: "wl-stat wl-stat--dark" }
const _hoisted_11 = { class: "wl-stat__head" }
const _hoisted_12 = { class: "wl-stat__title" }
const _hoisted_13 = { class: "wl-stat__value" }
const _hoisted_14 = { class: "wl-stat" }
const _hoisted_15 = { class: "wl-stat__head" }
const _hoisted_16 = { class: "wl-stat__title" }
const _hoisted_17 = { class: "wl-stat__value" }
const _hoisted_18 = { class: "wl-stat" }
const _hoisted_19 = { class: "wl-stat__head" }
const _hoisted_20 = { class: "wl-stat__title" }
const _hoisted_21 = { class: "wl-stat__value" }
const _hoisted_22 = { class: "wl-stat" }
const _hoisted_23 = { class: "wl-stat__head" }
const _hoisted_24 = { class: "wl-stat__title" }
const _hoisted_25 = { class: "wl-stat__value" }
const _hoisted_26 = {
  key: 0,
  class: "wl-stat"
}
const _hoisted_27 = { class: "wl-stat__head" }
const _hoisted_28 = { class: "wl-stat__title" }
const _hoisted_29 = {
  class: "wl-stat__value",
  style: {"font-size":"13px","font-weight":"600"}
}
const _hoisted_30 = {
  key: 0,
  class: "wl-stat__meta"
}
const _hoisted_31 = { class: "assets-grid-card mb-4" }
const _hoisted_32 = { class: "assets-grid-card__header" }
const _hoisted_33 = { class: "assets-grid-title" }
const _hoisted_34 = { class: "assets-grid-title__text" }
const _hoisted_35 = { class: "text-muted small" }
const _hoisted_36 = { class: "assets-grid-card__body p-3" }
const _hoisted_37 = { class: "wl-assets-search-wrap mb-2" }
const _hoisted_38 = ["placeholder"]
const _hoisted_39 = { class: "wl-assets-filters mb-3" }
const _hoisted_40 = { class: "wl-pills" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "text-center text-muted py-3"
}
const _hoisted_43 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_44 = { class: "table table-hover table-sm wld-table" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "fw-semibold font-monospace" }
const _hoisted_47 = { class: "wl-category-badge ms-2" }
const _hoisted_48 = { class: "text-muted font-monospace small" }
const _hoisted_49 = { class: "wld-value font-monospace small" }
const _hoisted_50 = { class: "wld-value font-monospace small" }
const _hoisted_51 = { class: "wld-value font-monospace small" }
const _hoisted_52 = { class: "wld-value font-monospace small" }
const _hoisted_53 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between mt-2 px-1"
}
const _hoisted_54 = { class: "text-muted small" }
const _hoisted_55 = { class: "d-flex align-items-center gap-2" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "text-muted small" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = {
  key: 0,
  class: "assets-grid-card"
}
const _hoisted_60 = { class: "assets-grid-card__header" }
const _hoisted_61 = { class: "assets-grid-title" }
const _hoisted_62 = { class: "assets-grid-title__text" }
const _hoisted_63 = { class: "text-muted small" }
const _hoisted_64 = { class: "assets-grid-card__body p-3 wad-charts row g-3" }
const _hoisted_65 = {
  key: 0,
  class: "col-12 col-md-6 wad-chart-block"
}
const _hoisted_66 = { class: "wad-chart-title" }
const _hoisted_67 = {
  key: 1,
  class: "col-12 col-md-6 wad-chart-block"
}
const _hoisted_68 = { class: "wad-chart-title" }
const _hoisted_69 = {
  key: 2,
  class: "col-12 col-md-6 wad-chart-block"
}
const _hoisted_70 = { class: "wad-chart-title" }
const _hoisted_71 = {
  key: 3,
  class: "col-12 col-md-6 wad-chart-block"
}
const _hoisted_72 = { class: "wad-chart-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "wad-back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasLocations.detail.backToList')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rangeOptions, (h) => {
            return (_openBlock(), _createElementBlock("button", {
              key: h.v,
              type: "button",
              class: _normalizeClass(["wl-pill", { 'wl-pill--active': _ctx.rangeHours === h.v }]),
              onClick: ($event: any) => (_ctx.setRange(h.v))
            }, _toDisplayString(h.l), 11, _hoisted_5))
          }), 128))
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("span", {
              class: "spinner-border wp-loading__spinner",
              role: "status"
            }, null, -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.loading')), 1)
          ]))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.error), 1)
            ]))
          : (_ctx.data)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.kpi.total')), 1),
                      _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-collection wl-stat__icon" }, null, -1))
                    ]),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.data.assets.length), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.kpi.active')), 1),
                      _cache[8] || (_cache[8] = _createElementVNode("i", {
                        class: "bi bi-activity wl-stat__icon",
                        style: {"color":"#3f8f52"}
                      }, null, -1))
                    ]),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.activeCount), 1),
                    _createElementVNode("div", {
                      class: "wl-stat__accent",
                      style: _normalizeStyle({ width: _ctx.data.assets.length ? `${(_ctx.activeCount/_ctx.data.assets.length)*100}%` : '0%', background: '#3f8f52' })
                    }, null, 4)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.kpi.inactive')), 1),
                      _cache[9] || (_cache[9] = _createElementVNode("i", {
                        class: "bi bi-exclamation-triangle wl-stat__icon",
                        style: {"color":"#e8833a"}
                      }, null, -1))
                    ]),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.data.assets.length - _ctx.activeCount), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.kpi.gateways')), 1),
                      _createElementVNode("i", {
                        class: "bi bi-broadcast-pin wl-stat__icon",
                        style: _normalizeStyle({ color: _ctx.data.online ? '#3f8f52' : '#e8833a' })
                      }, null, 4)
                    ]),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.data.gateways.length), 1)
                  ]),
                  (_ctx.data.address?.city)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.kpi.address')), 1),
                          _cache[10] || (_cache[10] = _createElementVNode("i", {
                            class: "bi bi-geo-alt wl-stat__icon",
                            style: {"color":"#f77f01"}
                          }, null, -1))
                        ]),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.data.address.city), 1),
                        (_ctx.data.address.street)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.data.address.street), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
                        _createElementVNode("i", { class: "bi bi-collection" })
                      ], -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.data.name), 1),
                        _createElementVNode("div", _hoisted_35, [
                          (_ctx.data.type)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["wirepas-type-badge me-2", `wirepas-type-badge--${_ctx.data.type}`])
                              }, _toDisplayString(_ctx.locTypeLabel(_ctx.data.type)), 3))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasLocations.detail.assetsSubtitle', { n: _ctx.data.assets.length })), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQ) = $event)),
                        type: "text",
                        class: "form-control wl-assets-search",
                        placeholder: _ctx.$t('components.wirepasLocations.detail.searchPlaceholder')
                      }, null, 8, _hoisted_38), [
                        [_vModelText, _ctx.searchQ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusFilters, (f) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: f.v,
                            type: "button",
                            class: _normalizeClass(["wl-pill", { 'wl-pill--active': _ctx.statusFilter === f.v }]),
                            onClick: ($event: any) => (_ctx.statusFilter = f.v)
                          }, _toDisplayString(f.l), 11, _hoisted_41))
                        }), 128))
                      ])
                    ]),
                    (!_ctx.filteredAssets.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.noAssets')), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("table", _hoisted_44, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.wirepasAssets.columns.asset')), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.wirepasAssets.columns.lastSeen')), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.temperature')), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.humidity')), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.battery')), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.rssi')), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.wirepasAssets.columns.status')), 1)
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedAssets, (a) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: a.id,
                                  class: "wld-row",
                                  onClick: ($event: any) => (_ctx.$router.push(`/wirepas-assets/${a.id}`))
                                }, [
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["wl-asset-dot me-1", a.active ? 'wl-asset-dot--active' : 'wl-asset-dot--inactive'])
                                    }, null, 2),
                                    _createElementVNode("span", _hoisted_46, _toDisplayString(a.name || a.serialNumber), 1),
                                    _createElementVNode("span", _hoisted_47, _toDisplayString(a.assetCategory), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.agoText(a.lastSeen)), 1),
                                  _createElementVNode("td", _hoisted_49, _toDisplayString(a.latest?.temperature != null ? a.latest.temperature.toFixed(1) + ' °C' : '—'), 1),
                                  _createElementVNode("td", _hoisted_50, _toDisplayString(a.latest?.humidity != null ? a.latest.humidity.toFixed(1) + ' %' : '—'), 1),
                                  _createElementVNode("td", _hoisted_51, _toDisplayString(a.latest?.battery != null ? (a.latest.battery / 1000).toFixed(2) + ' V' : '—'), 1),
                                  _createElementVNode("td", _hoisted_52, _toDisplayString(a.latest?.rssi != null ? a.latest.rssi.toFixed(1) + ' dBm' : '—'), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["wl-status-badge", `wl-status-badge--${a.status}`])
                                    }, _toDisplayString(_ctx.$t(`components.wirepasAssets.status.${a.status}`)), 3)
                                  ])
                                ], 8, _hoisted_45))
                              }), 128))
                            ])
                          ]),
                          (_ctx.pageCount > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.filteredAssets.length) + " " + _toDisplayString(_ctx.$t('components.wirepasLocations.detail.assetsTotal')), 1),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("button", {
                                    class: "wad-back",
                                    disabled: _ctx.page <= 1,
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.page--))
                                  }, "‹", 8, _hoisted_56),
                                  _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.page) + " / " + _toDisplayString(_ctx.pageCount), 1),
                                  _createElementVNode("button", {
                                    class: "wad-back",
                                    disabled: _ctx.page >= _ctx.pageCount,
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.page++))
                                  }, "›", 8, _hoisted_58)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ])
                ]),
                (_ctx.hasSeries)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
                            _createElementVNode("i", { class: "bi bi-graph-up" })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.charts')), 1),
                            _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('components.wirepasLocations.detail.chartsSubtitle')), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        (_ctx.rssiSeries.datasets[0]?.data?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                _cache[13] || (_cache[13] = _createElementVNode("i", {
                                  class: "bi bi-reception-4",
                                  style: {"color":"#f77f01"}
                                }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.rssi')) + " [dBm]", 1)
                              ]),
                              _createVNode(_component_LineChart, {
                                "chart-data": _ctx.rssiSeries,
                                options: _ctx.chartOptions('dBm'),
                                height: 160
                              }, null, 8, ["chart-data", "options"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.tempSeries.datasets[0]?.data?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                              _createElementVNode("div", _hoisted_68, [
                                _cache[14] || (_cache[14] = _createElementVNode("i", {
                                  class: "bi bi-thermometer-half",
                                  style: {"color":"#f77f01"}
                                }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.temperature')) + " [°C]", 1)
                              ]),
                              _createVNode(_component_LineChart, {
                                "chart-data": _ctx.tempSeries,
                                options: _ctx.chartOptions('°C'),
                                height: 160
                              }, null, 8, ["chart-data", "options"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.humSeries.datasets[0]?.data?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, [
                                _cache[15] || (_cache[15] = _createElementVNode("i", {
                                  class: "bi bi-droplet-half",
                                  style: {"color":"#f77f01"}
                                }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.humidity')) + " [%]", 1)
                              ]),
                              _createVNode(_component_LineChart, {
                                "chart-data": _ctx.humSeries,
                                options: _ctx.chartOptions('%'),
                                height: 160
                              }, null, 8, ["chart-data", "options"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.battSeries.datasets[0]?.data?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, [
                                _cache[16] || (_cache[16] = _createElementVNode("i", {
                                  class: "bi bi-battery-half",
                                  style: {"color":"#f77f01"}
                                }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.battery')) + " [V]", 1)
                              ]),
                              _createVNode(_component_LineChart, {
                                "chart-data": _ctx.battSeries,
                                options: _ctx.chartOptions('V'),
                                height: 160
                              }, null, 8, ["chart-data", "options"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
    ])
  ]))
}